module.exports = __webpack_public_path__ + "assets/img/LTC020.ee8fd47e.png";